const properPlaceTypes = ['city', 'town', 'village', 'island', 'countrySide', 'nationalPark'];

const isProperPlace = (placeType: string): boolean => {
  return properPlaceTypes.includes(placeType);
};

export default isProperPlace;
